import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppConstants } from '../../constants/app-constants';
import { AppRouters } from '../../constants/app-routers.router';
import { KeyStorage } from '../../constants/key-storage.stor';
import { AppStorageService } from '../../services/store/app-storage.service';
import { LoginResponseModel } from '../../../modules/auth/models/login-response.model';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private storage: AppStorageService) { }

  canActivate(): boolean {
    try {
      // محاولة استرجاع token كـ LoginResponseModel أولاً
      const tokenData = this.storage.getItem<any>(KeyStorage.keyLocalToken);
      
      console.warn('AuthGuard - Token check:', tokenData);

      // التحقق من وجود token صالح
      let isValidToken = false;

      if (!tokenData) {
        // لا يوجد token
        isValidToken = false;
      } else if (typeof tokenData === 'object' && tokenData !== null) {
        // إذا كان object (LoginResponseModel)
        const accessToken = tokenData.access_token || (tokenData as any)?.value?.access_token;
        const hasData = tokenData.data || (tokenData as any)?.value?.data;
        const message = tokenData.message || (tokenData as any)?.value?.message;
        
        // التحقق من وجود token (حتى لو كان 'true') مع وجود data أو message = 'ok'
        // النظام يستخدم 'true' كقيمة صالحة للـ token
        if (accessToken && typeof accessToken === 'string' && accessToken.trim() !== '') {
          // إذا كان access_token موجود (حتى لو كان 'true') وله data أو message = 'ok'
          isValidToken = (hasData !== null && hasData !== undefined) || 
                        (message && message.toLowerCase().trim() === 'ok') ||
                        accessToken !== 'null' && accessToken !== 'undefined';
        }
      } else if (typeof tokenData === 'string') {
        // إذا كان string مباشرة
        isValidToken = tokenData.trim() !== '' &&
                       tokenData !== 'null' &&
                       tokenData !== 'undefined';
      }

      if (isValidToken) {
        // مسجل دخول → يسمح بالدخول
        console.warn('AuthGuard - Valid token, allowing access');
        return true;
      } else {
        // غير مسجل دخول أو token غير صالح → يوجه إلى صفحة تسجيل الدخول
        console.warn('AuthGuard - No valid token, redirecting to login');
        // تنظيف token غير صالح
        this.storage.removeItem(KeyStorage.keyLocalToken);
        this.router.navigate([AppRouters.auth_SignIn]);
        return false;
      }
    } catch (error) {
      console.error('AuthGuard - Error checking token:', error);
      // في حالة حدوث خطأ، نوجه إلى تسجيل الدخول
      this.storage.removeItem(KeyStorage.keyLocalToken);
      this.router.navigate([AppRouters.auth_SignIn]);
      return false;
    }
  }
}
